<template>
  <div
    class="flex w-full items-center justify-between rounded-lg border p-2"
    :class="{
      'border-primary-600 bg-primary-50 text-primary-900 dark:border-primary-dark-700 dark:bg-primary-dark-900 dark:text-primary-dark-200':
        type === AlertTypes.Info,
      'border-green-600 bg-green-100 text-green-900 dark:border-green-700 dark:bg-green-900 dark:text-green-300':
        type === AlertTypes.Success,
      'border-yellow-600 bg-yellow-100 text-yellow-900 dark:border-yellow-700 dark:bg-yellow-800 dark:text-yellow-200':
        type === AlertTypes.Warning,
      'border-yapred-600 bg-red-100 text-yapred-900 dark:border-yapred-700 dark:bg-yapred-900 dark:text-yapred-100':
        type === AlertTypes.Error
    }"
    v-if="showAlert"
  >
    <div>
      <strong v-if="title">{{ title }}</strong>
      <p>{{ message }}</p>
    </div>
    <YapButtonIcon
      class="rounded-full hover:bg-transparent"
      :class="{
        'text-primary-900 dark:text-primary-dark-900': type === AlertTypes.Info,
        'text-green-900': type === AlertTypes.Success,
        'text-yellow-900': type === AlertTypes.Warning,
        'text-yapred-900': type === AlertTypes.Error
      }"
      @click="dismissAlert"
      v-if="dismissable || !!autoDismissDelay"
    >
      <YapIcon name="close-outline" class="h-6 w-6" />
    </YapButtonIcon>
  </div>
</template>

<script lang="ts">
export enum AlertTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}
</script>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import YapIcon from '@/components/YapIcon.vue';
import YapButtonIcon from '@/components/YapButtonIcon.vue';

const emit = defineEmits(['dismissed']);
const props = withDefaults(
  defineProps<{
    message: string;
    title?: string;
    type?: AlertTypes;
    dismissable?: boolean;
    autoDismissDelay?: number;
  }>(),
  {
    title: undefined,
    type: AlertTypes.Info,
    autoDismissDelay: undefined
  }
);

const showAlert = ref(true);

function dismissAlert() {
  showAlert.value = false;
  emit('dismissed');
}

onMounted(() => {
  if (!!props.autoDismissDelay) {
    setTimeout(() => {
      dismissAlert();
    }, props.autoDismissDelay);
  }
});
</script>
